import type { AlertProps } from "@chakra-ui/react";
import { BannerAlert } from "@equidefi/ui";

import { attemptsWarning } from "../helpers/errors";

export const AttemptsWarning = ({ error, ...props }: { error: unknown } & Omit<AlertProps, "status">) => {
  const warning = attemptsWarning(error);
  if (!warning) return null;

  return <BannerAlert status="warning" titleLayout="stacked" hideIcon={false} p={4} title={warning} {...props} />;
};
